import { render, staticRenderFns } from "./resMain.vue?vue&type=template&id=4ecc1c8c&scoped=true"
import script from "./resMain.vue?vue&type=script&lang=js"
export * from "./resMain.vue?vue&type=script&lang=js"
import style0 from "./resMain.vue?vue&type=style&index=0&id=4ecc1c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc1c8c",
  null
  
)

export default component.exports